import { cn } from '../../lib/cn';
import { Card } from './Card';
import { ConfidenceIndicator } from './ConfidenceIndicator';
import { Badge } from './Badge';

type Props = {
  title: string;
  description?: string;
  confidence: number;
  expectedImpact?: string;
  priorityRank?: number;
  requiresApproval?: boolean;
  type?: string;
  className?: string;
};

export function AIRecommendationCard({
  title, description, confidence, expectedImpact, priorityRank, requiresApproval, type, className,
}: Props) {
  return (
    <Card className={cn('border-ai-200 dark:border-ai-800', className)}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div className="flex-1">
          <div className="flex flex-wrap items-center gap-2">
            <Badge variant="ai">AI</Badge>
            {priorityRank != null && <span className="text-xs text-slate-400">#{priorityRank}</span>}
            {type && <span className="text-xs text-slate-500">{type.replace(/_/g, ' ')}</span>}
          </div>
          <h3 className="mt-2 font-medium text-slate-900 dark:text-slate-100">{title}</h3>
          {description && <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{description}</p>}
        </div>
        <ConfidenceIndicator score={confidence} />
      </div>
      <div className="mt-3 flex flex-wrap gap-3 text-xs text-slate-500">
        {expectedImpact && <span>Impact: {expectedImpact}</span>}
        {requiresApproval && <span className="text-warning-600">Requires approval</span>}
      </div>
    </Card>
  );
}
